<template>
    <div autocomplete="off" >
      <form>
        <div class="row">
          <div class="col">
            <div class="element-wrapper">
                  <h6 class="element-header">
                    Resumo da Compra
                  </h6>
                  <div class="row">
                    <div class="col">
                      <table class="table table-clean">
                        <tbody>
                          <tr>
                            <td>
                              <div class="value">
                                Plano: <b>{{payload.plano.name}}</b>
                              </div>
                              <span class="sub-value"></span>
                            </td>
                            <td class="text-right">
                              <div class="value">
                                {{ (payload.plano.price || 0) | money}} / mês
                              </div>
                            </td>
                          </tr>
                          <tr v-if="payload.plano.valorTaxaAdesao">
                            <td>
                              <div class="value">
                                Taxa de Adesão: {{payload.plano.valorTaxaAdesao | money}}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <hr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="label">Nome Titular</div>
                      <h6>{{payload.name}}</h6>
                    </div>
                    <div class="col-md-6 col-6">
                      <div class="label">E-mail</div>
                      <h6>{{payload.email}}</h6>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="label">Sexo</div>
                      <h6>{{payload.sexo}}</h6>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-6 col-xs-6">
                      <div class="label">Estado Civil</div>
                      <h6>Casado</h6>
                    </div>
                    <div class="col-6">
                      <div class="label">CPF</div>
                      <h6>{{payload.cpf}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Naturalidade</div>
                      <h6>{{payload.naturalidade}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Estado</div>
                      <h6>{{payload.uf}}</h6>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col">
                      <div class="label">Celular</div>
                      <h6>{{payload.telefoneCelular}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Data de nascimento</div>
                      <h6>{{payload.dataNascimento}}</h6>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col">
                      <label for="">Endereço</label>
                      <h6>{{payload.enderecoResidencial}}</h6>
                    </div>
                    <div class="col-md-2 col-3">
                      <label for="">Número</label>
                      <h6>{{payload.enderecoNumero}}</h6>
                    </div>
                    <div class="col-md-5 col-xs-12">
                      <label for="">Complemento</label>
                      <h6>{{payload.endereComplemento}}</h6>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col">
                      <label for="">Bairro</label>
                      <h6>{{payload.bairro}}</h6>
                    </div>
                    <div class="col-md-3 col-xs-6">
                      <label for="">Cidade</label>
                      <h6>{{payload.cidade}}</h6>
                    </div>
                    <div class="col-1">
                      <label for="">UF</label>
                      <h6>{{payload.uf}}</h6>
                    </div>
                    <div class="col-md-3 col-xs-6">
                      <label for="">CEP</label>
                      <h6>{{payload.cep}}</h6>
                    </div>
                  </div>

                </div>
          </div>
        </div>
        <template v-if="!empresa.utilizaPlataformaPagamento">
          <div class="row">
            <div class="col text-right">
              <b-button @click="voltar">Voltar</b-button>&nbsp;
              <b-button @click="assinarPlano" variant="primary">Assinar Plano Faturado</b-button>
            </div>
          </div>
        </template>
        <template v-else-if="empresa.utilizaPlataformaPagamento">
          <div class="row">
            <div class="col">
              <h4>Pagamento</h4>
            </div>
          </div>
          <hr />
          <!-- <div class="row">
            <div class="col">
               <b-form-checkbox v-model="checkedCartaoFisico" name="check-button" switch>
                Dejesa comprar o cartão Físico?
              </b-form-checkbox>
            </div>
          </div> -->
          <hr/>
          <div class="row">
            <b-form-group label="Escolha a forma de pagamento">
              <b-form-radio-group
                id="formaPagamento"
                v-model="form.vads_payment_cards"
                name="formaPagamento"
              >
                <b-form-radio
                  v-for="option in formasDePagamento"
                  v-model="form.vads_payment_cards"
                  :key="option.value"
                  :value="option"
                >
                  <img :src="option.image" :title="option.descricao" />
                  <span>{{option.descricao}}</span>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="row" v-if="form.vads_payment_cards.tipoPagamento === 'Boleto' || form.vads_payment_cards.tipoPagamento === 'carne'">
            <b-form-group class="col-md-12" label="Escolha o dia para o vencimento do Boleto">
              <b-form-select
                v-model="form.client.diaVencimentoBoleto"
                :options="diasVencimentoBoleto"
                text-field="value"
                value-field="key"
              ></b-form-select>
            </b-form-group>
            <div class="col text-center">
              <b-button @click="assinarPlano">Assinar Plano</b-button>
            </div>
          </div>

          <div class="container" v-if="form.vads_payment_cards.tipoPagamento === 'cartaoCredito'">
            <form>
              <div class="form-desc">
              <i class="fas fa-lock"></i> Compra Segura
            </div>
            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-right" for>Número do Cartão</label>
              <div class="col-sm-8">
                <img :src="bandeira" alt="bandeira-cartao" height="50" />
                <input
                  v-model="form.vads_card_number"
                  class="form-control form-control-lg"
                  placeholder="Digite apenas os números"
                  type="tel"
                  v-card
                  v-mask="'#### #### #### ####'"
                  required
                />
                <small>Sem pontos, espaços e hífens</small>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-right" for>Nome impresso no cartão</label>
              <div class="col-sm-8">
                <input
                  v-model="form.vads_order_id"
                  class="form-control"
                  placeholder="Digite o nome"
                  type="text"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-right" for>Validade</label>
              <div class="col-md-4 col-6">
                <input
                  class="form-control"
                  placeholder="Mês com 2 dígitos. Ex. 03"
                  type="tel"
                  v-model="form.vads_expiry_month"
                  minlength="2"
                  maxlength="2"
                  size="4"
                  v-mask="'##'"
                  required
                />
              </div>
              <div class="col-md-4 col-6">
                <input
                  class="form-control"
                  placeholder="Ano com 4 dígitos. Ex. 2019"
                  type="tel"
                  v-model="form.vads_expiry_year"
                  minlength="4"
                  maxlength="4"
                  size="4"
                  v-mask="'####'"
                  required
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-sm-4 text-right" for>Código de Segurança</label>
              <div class="col-sm-8">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="validationTooltipUsernamePrepend">
                      <a href="#">
                        <i class="far fa-question-circle"></i>
                      </a>
                    </span>
                  </div>
                  <input
                    v-model="form.vads_cvv"
                    type="tel"
                    class="form-control"
                    id="validationTooltipUsername"
                    aria-describedby="validationTooltipUsernamePrepend"
                    required
                    minlength="3"
                    maxlength="3"
                    placeholder="Com 3 dígitos. Ex. 123"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <b-button @click="assinarPlano">Assinar Plano</b-button>
              </div>
            </div>
            </form>
          </div>

          <div class="container" v-if="form.vads_payment_cards.tipoPagamento === 'debitoConta'">
            <form>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>Agência</label>
                    <input type="tel" class="form-control" v-model="form.agencia">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>Conta</label>
                    <input type="tel" class="form-control" v-model="form.numeroConta">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>Dia débito</label>
                    <input type="tel" class="form-control" v-model="form.diaDebito">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col text-center">
                  <b-button @click="assinarPlano">Assinar Plano</b-button>
                </div>
              </div>
            </form>
          </div>

          <div class="container" v-if="form.vads_payment_cards.tipoPagamento === 'dinheiro' || form.vads_payment_cards.tipoPagamento === 'outros'">
          <div class="row">
            <div class="col text-center">
              <b-button @click="assinarPlano">Assinar Plano</b-button>
            </div>
          </div>
        </div>

        </template>
        <template v-else>
          <div class="row">
            <div class="col text-right">
              <b-button @click="voltar">Voltar</b-button>&nbsp;
              <b-button @click="assinarPlano" variant="primary">Cadastrar</b-button>
            </div>
          </div>
        </template>
      </form>
    </div>
</template>
<script>
import http from 'axios';
import moment from 'moment';
import pagarme from 'pagarme';

export default {
    props: {
        payload: {
            type: Object,
            required: true
        }
    },
    computed: {
        step() {
            return this.$store.getters.step;
        },
        empresa() {
            return this.$store.getters.empresa;
        },
        user() {
          return this.$store.getters.user;
        },
        utilizaPagarme() {
          return this.empresa && this.empresa.utilizaPlataformaPagamento && this.empresa.plataformaPagamento === 'Pagar.me';
        }
    },
    data() {
        return {
            bandeira: require('@/assets/images/cartao_vazio.png'),
            form: {
                cupon: {},
                client: {
                diaVencimentoBoleto: null
                },
                juridica: {},
                plano: {},
                vendedor: {},
                vads_action_mode: "SILENT",
                vads_amount: 0,
                vads_sub_init_amount_number: 1,
                vads_sub_init_amount: 0,
                vads_trans_date: "",
                vads_trans_id: "",
                vads_order_id: "",
                vads_validation_mode: 0,
                vads_card_number: "",
                vads_expiry_month: "",
                vads_expiry_year: "",
                vads_cvv: "",
                vads_payment_cards: {}
            },
            formasDePagamento: [
                {
                value: "VISA",
                descricao: "CARTÃO DE CRÉDITO",
                image: require("@/assets/images/cartao_vazio.png"),
                tipoPagamento: "cartaoCredito"
                },
                {
                value: "ITAU_IB",
                descricao: "BOLETO",
                image: require("@/assets/img/cartoes/boleto_itau.png"),
                tipoPagamento: "Boleto"
                },
                {
                value: 'CARNẼ',
                descricao: 'CARNẼ de 12 meses',
                image: require("@/assets/img/cartoes/boleto_itau.png"),
                tipoPagamento: 'carne'
                }
            ],
            diasVencimentoBoleto: [
                { key: "", value: "Vencimento Padrão" },
                { key: "0", value: "Hoje" },
                { key: "1", value: "1 dia" },
                { key: "2", value: "2 dias" },
                { key: "3", value: "3 dias" },
                { key: "4", value: "4 dias" },
                { key: "5", value: "5 dias" },
                { key: "6", value: "6 dias" },
                { key: "7", value: "7 dias" },
                { key: "8", value: "8 dias" },
                { key: "9", value: "9 dias" },
                { key: "10", value: "10 dias" },
                { key: "11", value: "11 dias" },
                { key: "12", value: "12 dias" },
                { key: "13", value: "13 dias" },
                { key: "14", value: "14 dias" },
                { key: "15", value: "15 dias" },
                { key: "16", value: "16 dias" },
                { key: "17", value: "17 dias" },
                { key: "18", value: "18 dias" },
                { key: "19", value: "19 dias" },
                { key: "20", value: "20 dias" },
                { key: "21", value: "21 dias" },
                { key: "22", value: "22 dias" },
                { key: "23", value: "23 dias" },
                { key: "24", value: "24 dias" },
                { key: "25", value: "25 dias" },
                { key: "26", value: "26 dias" },
                { key: "27", value: "27 dias" },
                { key: "28", value: "28 dias" },
                { key: "29", value: "29 dias" },
                { key: "30", value: "30 dias" },
                { key: "31", value: "31 dias" }
            ]
        }
    },
    methods: {
      voltar() {
        this.$store.dispatch('setStep', 'dadosDependentes');
      },
        next(from, to) {
            this.$validator.validateAll(from).then(result => {
                if (result) {
                    this.$store.dispatch('setStep', to);
                }
            });
        },
        async assinarPlano() {
            this.$store.dispatch('setLoading', true);

            this.form.plano = this.payload.plano;

            this.form.juridica = this.empresa;
            this.form.vendedor = this.user;

            this.form.formadePagamento = this.form.vads_payment_cards.tipoPagamento;

            this.payload.juridica = this.empresa;
            this.payload.vendedor =  this.user;
            this.payload.status = 'Desabilitado';
            this.payload.dataNascimento = moment(this.payload.dataNascimento, 'DD/MM/YYYY').toDate().getTime();

            this.payload.diaVencimentoBoleto = this.form.client.diaVencimentoBoleto;

            try {
                const data = {
                  client: this.payload,
                  saude: this.form
                };
                if (this.utilizaPagarme && this.form.formadePagamento === 'cartaoCredito') {
                  const client = await pagarme.client.connect({ encryption_key: process.env.PAGARME_ENCRYPT || 'ek_test_8dMhnWT9HRX57H0Yui244fT1fFGpXa' });
                  data.saude.cardHash = await client.security.encrypt({
                    card_holder_name: this.form.vads_order_id,
                    card_expiration_date: this.form.vads_expiry_month + '/' + this.form.vads_expiry_year,
                    card_number: this.form.vads_card_number,
                    card_cvv: this.form.vads_cvv
                  });
                  this.form.vads_order_id = null;
                  this.form.vads_expiry_month = this.form.vads_expiry_year = null;
                  this.form.vads_card_number = null;
                  this.form.vads_cvv = null;
                }
                const response = await http.post('/api/saude/writelabel', data);

                this.$store.dispatch('setLoading', false);
                const saude = response.data;

                if (saude.formadePagamento === 'Boleto') {
                  window.open(saude.urlBoletoInicial);
                }
                this.$bvToast.toast(`Pedido ${saude.idPedidoVindi} gerado com sucesso!`, {
                title: `Pedido criado com sucesso`,
                variant: 'success',
                solid: true
                });

                this.$router.push({name: 'PedidoDetail', query: {id: saude._id}});

            } catch (error) {
                this.$store.dispatch('setLoading', false);
                if (this.form.client && this.form.client._id) {
                await http.delete(`/api/client/${this.form.client._id}`);
                }
                // eslint-disable-next-line
                console.log('ERROR =>', error.response);
                const errorMessage = error.response.data;
                if (errorMessage.code && errorMessage.message) {
                  this.$bvToast.toast(errorMessage.code +  ' - ' + errorMessage.message, {
                    title: `Falha ao processar o Pagamento`,
                    variant: 'danger',
                    solid: true
                  });
                } else {
                  this.$bvToast.toast('Dados para o pagamento inválido. Favor Verificar!', {
                    title: `Falha ao cadastrar Pedido`,
                    variant: 'danger',
                    solid: true
                  });
                }

            } finally {
                this.$store.dispatch('setLoading', false);
            }
        }
    }
}
</script>
